import { useEffect, useState } from 'react';
/**
 * Live IntersectionObserver hook: returns `true` while the observed element
 * intersects the viewport at >= `threshold`, updating on every cross. Unlike
 * `useBelowFoldImpression` (fire-once), this reflects the current visibility
 * state continuously. SSR-safe (returns `false` until observed).
 */
export const useIsInView = function (ref, _temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.1 : _ref$threshold;
  const _useState = useState(false),
    inView = _useState[0],
    setInView = _useState[1];
  useEffect(() => {
    if (!enabled) {
      setInView(false);
      return;
    }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }
    const observer = new IntersectionObserver(_ref2 => {
      let entry = _ref2[0];
      if (entry) {
        setInView(entry.intersectionRatio >= threshold);
      }
    }, {
      threshold: [0, threshold, 1]
    });
    observer.observe(el);
    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
  }, [enabled, ref, threshold]);
  return inView;
};
export const useIsBelowViewport = function (ref, _temp2) {
  let _ref3 = _temp2 === void 0 ? {} : _temp2,
    _ref3$enabled = _ref3.enabled,
    enabled = _ref3$enabled === void 0 ? true : _ref3$enabled;
  const _useState2 = useState(false),
    isBelow = _useState2[0],
    setIsBelow = _useState2[1];
  useEffect(() => {
    if (!enabled) {
      setIsBelow(false);
      return;
    }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }
    const observer = new IntersectionObserver(_ref4 => {
      let entry = _ref4[0];
      if (entry) {
        setIsBelow(!entry.isIntersecting && entry.boundingClientRect.top > 0);
      }
    }, {
      threshold: 0
    });
    observer.observe(el);
    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
  }, [enabled, ref]);
  return isBelow;
};
//# sourceMappingURL=useIsInView.js.map